import { createAsyncThunk, createSlice, current, PayloadAction } from "@reduxjs/toolkit"
import { insertFeedBackAsync, SaveFeedBackDto } from "./feedBackAPI"
import { RootState } from "../../app/store"
import { dateToTransmissionDateTime } from "../../utils/dateUtils"

export interface FeedbackState {
    body : string
    id : number
    okToSend : boolean
}
const initialState : FeedbackState = {
    body : '',
    id: 0,
    okToSend: false
}
export interface SaveFeedBackRequest {
    token: string,
    email: string 
}

export const addFeedbackAsync = createAsyncThunk(
    'feedback/addFeedback' ,
    async (request: SaveFeedBackRequest, { getState}) => {
        const {currentFeedback} = getState() as {currentFeedback: FeedbackState}
        let saveFeedbackDto: SaveFeedBackDto = {
            body : currentFeedback.body,
            email: request.email,
            id: currentFeedback.id,
            feedBackTime: dateToTransmissionDateTime(new Date())
        }
    const response = await insertFeedBackAsync(saveFeedbackDto, request.token)
    return response
    },
)

export const currentFeedbackSlice = createSlice({
    name: 'currentFeedback',
    initialState: initialState,
    reducers: {
        setFeedback: (state, action: PayloadAction<string>) => {
            state.body = action.payload
            state.okToSend = (state.body.trim().length>0)
        }
    }
})

export const { setFeedback } = currentFeedbackSlice.actions
export const selectOkToSend = (state: RootState) => state.currentFeedback.okToSend;
export const selectFeedbackBody = (state: RootState) => state.currentFeedback.body;
export default currentFeedbackSlice.reducer
